import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import PageHeader from "@/components/UI/PageHeader.vue";
import CountriesMultiSelect from "@/components/UI/Form/CountriesMultiSelect.vue";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import ApiEnter from "@/api/ApiEnter";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import ApiShopOptions from "@/api/ApiShopOptions";
import sweetalert from "sweetalert";
import DataOptions from "@/data/AdminPanel/DataOptions";
import CKEditorConfig from "@/data/CKeditor/config";
import ApiAdmin from "@/api/ApiAdmin";
let OptionsCreate = class OptionsCreate extends Vue {
    constructor() {
        super(...arguments);
        this.editor = ClassicEditor;
        this.Breadcrumbs = DataOptions.BreadcrumbsCreate;
        this.editorConfig = CKEditorConfig.editorConfig(ApiEnter.CurrentSessionUUID);
        this.roamingCategory = null;
        this.PeriodTypes = ["al ora", "al giorno", "alla settimana", "al mese", "al anno"];
        this.MeasureTypes = ["SMS", "Giga", "Mega", "SIM", "Minuti", "Pezzo", "Servizio"];
        this.optionsCategories = [];
        this.extraEuCountries = [];
        this.bssAddOns = [];
        this.bssLoading = false;
        this.newOption = {
            name: "",
            priority: "",
            publish: true,
            type: "extra",
            price: "",
            period: "",
            other_text: "",
            value: "",
            measure: "",
            value_1: "",
            measure_1: "",
            category_uuid: "",
            countries_uuid: [],
            connect: "",
            link_for_button: "",
            limits: "",
            overview: "",
            note: "",
            bss: "",
            bss_dependent_option: null,
            seo_title: "",
            seo_description: "",
            seo_keywords: "",
            seo_url: "",
            active: "active",
            tariff_overview: "",
            prospects_info: null,
            contract: null,
        };
        this.HasLoading = false;
    }
    async created() {
        let getOptionsCategories = await ApiShopOptions.GetOptionCategories();
        if (getOptionsCategories?.length)
            this.optionsCategories = getOptionsCategories;
        let getExtraEuCountries = await ApiShopOptions.GetExtraEuCountries();
        if (getExtraEuCountries?.length)
            this.extraEuCountries = getExtraEuCountries;
        let roamingUuid = await ApiShopOptions.GetRoamingCategory();
        if (roamingUuid) {
            this.roamingCategory = roamingUuid;
        }
        this.bssAddOns = await ApiShopOptions.GetBssDependentOptions(ApiEnter.CurrentSessionUUID);
    }
    async OnRefreshBssAddOns() {
        this.bssLoading = true;
        this.bssAddOns = await ApiShopOptions.RefreshBssDependentOptions(ApiEnter.CurrentSessionUUID);
        this.bssLoading = false;
    }
    GenerateSeoUrl() {
        let url = this.Translit(this.newOption.name.replace(/[\s]+/gi, "-"));
        this.newOption.seo_url = url.replace(/[^0-9a-z_-]+/gi, "").toLowerCase();
    }
    Translit(str) {
        let ru = "А-а-Б-б-В-в-Ґ-ґ-Г-г-Д-д-Е-е-Ё-ё-Є-є-Ж-ж-З-з-И-и-І-і-Ї-ї-Й-й-К-к-Л-л-М-м-Н-н-О-о-П-п-Р-р-С-с-Т-т-У-у-Ф-ф-Х-х-Ц-ц-Ч-ч-Ш-ш-Щ-щ-Ъ-ъ-Ы-ы-Ь-ь-Э-э-Ю-ю-Я-я".split("-");
        let en = "A-a-B-b-V-v-G-g-G-g-D-d-E-e-E-e-E-e-ZH-zh-Z-z-I-i-I-i-I-i-J-j-K-k-L-l-M-m-N-n-O-o-P-p-R-r-S-s-T-t-U-u-F-f-H-h-TS-ts-CH-ch-SH-sh-SCH-sch-'-'-Y-y-'-'-E-e-YU-yu-YA-ya".split("-");
        let res = "";
        for (let i = 0, l = str.length; i < l; i++) {
            let s = str.charAt(i), n = ru.indexOf(s);
            if (n >= 0) {
                res += en[n];
            }
            else {
                res += s;
            }
        }
        return res;
    }
    ValidateSeoUrl() {
        this.newOption.seo_url = this.Translit(this.newOption.seo_url.replace(/[. ,$@!^()'*]+/g, "-").toLowerCase());
    }
    async OnClickSubmit() {
        this.HasLoading = true;
        if (ApiEnter.CurrentSessionUUID != undefined) {
            this.$forceUpdate();
            const option_uuid = await ApiShopOptions.CreateOption(ApiEnter.CurrentSessionUUID, this.newOption.name, this.newOption.priority, this.newOption.publish ? 1 : 0, this.newOption.type, this.newOption.price, this.newOption.period, this.newOption.other_text, this.newOption.value, this.newOption.measure, this.newOption.value_1, this.newOption.measure_1, this.newOption.category_uuid, this.newOption.countries_uuid, this.newOption.connect, this.newOption.link_for_button, this.newOption.limits, this.newOption.overview, this.newOption.note, this.newOption.bss, this.newOption.bss_dependent_option, this.newOption.seo_title, this.newOption.seo_description, this.newOption.seo_keywords, this.newOption.seo_url, this.newOption.active === "active" ? 1 : 0, this.newOption.tariff_overview, this.newOption.prospects_info != null ? (await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newOption.prospects_info)) : "", this.newOption.contract != null ? (await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newOption.contract)) : "");
            if (option_uuid == undefined || option_uuid.length != 36) {
                await sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info",
                });
                return;
            }
            sweetalert({
                title: this.$t("general.success"),
                text: this.$t("general.success_created"),
                icon: "success",
            }).then(() => {
                this.$forceUpdate();
                this.$router.push(`/shop/options`);
            });
        }
        this.HasLoading = false;
    }
    async selectService() {
        this.newOption.category_uuid = '';
        this.newOption.countries_uuid = [];
    }
};
OptionsCreate = __decorate([
    Component({
        components: { StandartTemplate, PageHeader, CKEditor, CountriesMultiSelect },
    })
], OptionsCreate);
export default OptionsCreate;
